import { render, staticRenderFns } from "./FaceCategory.vue?vue&type=template&id=3f1ff793&"
import script from "./FaceCategory.vue?vue&type=script&lang=js&"
export * from "./FaceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports